import { FC } from 'react';

const NotFound: FC = () => {
  return <div>Not Found</div>;
};

export default NotFound;
